module.exports = __webpack_public_path__ + "img/320.e4ef8f59.jpg";